"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.somethingtopreventlint = exports.CONTEXT_ACTIONS = void 0;
// eslint-disable-next-line no-shadow
var CONTEXT_ACTIONS;
(function (CONTEXT_ACTIONS) {
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["RESET_STATE"] = 0] = "RESET_STATE";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_GEO_CURRENCY"] = 1] = "SET_GEO_CURRENCY";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_GEO_LOCATION"] = 2] = "SET_GEO_LOCATION";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_SELECTED_CRYPTO"] = 3] = "SET_SELECTED_CRYPTO";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_SELECTED_FIAT"] = 4] = "SET_SELECTED_FIAT";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_FIAT_VALUE"] = 5] = "SET_FIAT_VALUE";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_CRYPTO_VALUE"] = 6] = "SET_CRYPTO_VALUE";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_AUTOSELECT_PROVIDER"] = 7] = "SET_AUTOSELECT_PROVIDER";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_PROVIDER"] = 8] = "SET_PROVIDER";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_ADDRESS"] = 9] = "SET_ADDRESS";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_DEBUG_OPTIONS"] = 10] = "SET_DEBUG_OPTIONS";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["SET_PASS_THROUGH_ADDRESS"] = 11] = "SET_PASS_THROUGH_ADDRESS";
    CONTEXT_ACTIONS[CONTEXT_ACTIONS["TOGGLE_DEBUG"] = 12] = "TOGGLE_DEBUG";
})(CONTEXT_ACTIONS = exports.CONTEXT_ACTIONS || (exports.CONTEXT_ACTIONS = {}));
exports.somethingtopreventlint = "";
//# sourceMappingURL=actions.js.map